export type ImageType = 'certification' | 'icon';
const allImageModules = import.meta.glob<{ default: string }>(
	['/src/assets/images/certifications/*.png', '/src/assets/images/icons/*.png'],
	{ eager: true }
);
export const getImageUrl = (name: string, type: ImageType): string => {
	let folderImg;

	switch (type) {
		case 'certification':
			folderImg = 'certifications';
			break;
		case 'icon':
			folderImg = 'icons';
			break;
		default:
			return '';
	}
	const imageKey = `/src/assets/images/${folderImg}/${name}.png`;

	const module = allImageModules[imageKey];

	if (module) {
		return module.default;
	} else {
		return '';
	}
};
